import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { SanitizeHtml, SmoothLink, Sticky, GoogleMapUrl, buildThumbnailUrl, Image } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import LightBox from '@bd/bdui-lightbox';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import CoreMap from '@bd/bdui-coremap';
import HomesList from '../Homes/HomesList';
import PlansList from '../Plans/PlansList';
import PageWrapper from '../../components/PageWrapper';
import AccordionToggle from '../../components/AccordionToggle';
import Carousel from '../../components/Carousel';
import ContactModal from '../../components/ContactModal';
import { colors, typography } from '../../styles';
import SitePlan from './SitePlan';

const styles = css`

  .Breadcrumbs_wrapper {
    padding:20px;
  }
  .Breadcrumbs_list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .Breadcrumbs_listItem {
    display: inline-block;
    margin: 0;
    font-size: 14px;
    color: ${colors.color6};
    &:after {
      content: '/';
      margin: 0 5px;
      display: inline-block;
    }
    &:last-child:after {
      display: none;
    }
    a {
      color: ${colors.color2};
      font-weight: bold;
    }
  }
  .DetailHeader {
    @media (min-width: 992px) {
      padding: 60px 0;
      background-color: #F5F5F5;
      margin: 0;
    }
  }

  .DetailHeader_content {
    position: relative;
    margin: 0 -15px;
    @media (min-width: 992px) {
      margin: 0;
    }
    h1 {
      font-weight: 700;
      font-size: 20px;
      line-height: 18px;
      margin: 0 0 10px 0;
      padding: 15px;
      color: ${colors.color1};
      span {
        font-size: 15px;
        font-weight: 400;
      }
      @media (min-width: 992px) {
        font-size: 24px;
        line-height: 24px;
        border-bottom: 1px solid ${colors.color2};
        padding: 0 0 15px 0;
        span {
          font-size: 18px;
        }
      }
    }
  }
  .DetailHeader_contentMapButton {
    position: absolute;
    right: 15px;
    top: 8px;
    background-image: url('/images/icon-map-pin-blue.svg');
    display: block;
    width: 30px;
    height: 40px;
    padding: 21px 0 0 0;
    background-size: 14px 25px;
    background-repeat: no-repeat;
    background-position: top center;
    text-align: center;
    color: ${colors.color1};
    font-size: 12px;
    font-weight: 700;
    @media (min-width: 992px) {
      right: 0;
    }
  }
  .DetailHeader_iconList {
    display: flex;
    list-style: none;
    margin: 0 0 15px 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 10px 0 0 0;
    }
    li {
      font-size: 15px;
      line-height: 1;
      margin: 0 15px 0 0;
      @media (min-width: 1200px) {
        font-size: 16px;
        margin: 0 20px 0 0;
      }
    }
    li:last-child {
      margin: 0;
    }
  }
  .DetailHeader_iconListIcon {
    display: inline-block;
    vertical-align: middle;
    margin: -2px 5px 0 0;
  }
  .DetailHeader_priceWrapper {
    padding: 0 15px;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_priceValue {
    font-size: 20px;
    color: ${colors.color1};
    font-weight: 700;
    margin: 0;
    @media (min-width: 992px) {
      font-size: 24px;
    }
  }
  .DetailHeader_priceMonthly {
    font-size: 14px;
    font-weight: 300;
    font-style: italic;
    margin-left: 5px;
    @media (min-width: 992px) {
      display: block;
      padding: 10px 15px;
      background-color: #FFFFFF;
      font-size: 18px;
      font-weight: 700;
      font-style: normal;
      margin: 15px 0 20px 0;
      color: ${colors.color2};
    }
  }
  .DetailHeader_buttonsWrapper {
    padding: 0 15px;
    margin: 0 0 30px 0;
    @media (min-width: 992px) {
      padding: 0;
    }
    span:focus {
      outline: none;
      box-shadow: none;
    }
  }
  .DetailHeader_iconButtonsList {
    list-style: none;
    display: flex;
    justify-content: flex-start;
    padding: 0;
    padding: 0 15px;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailHeader_iconButtonsListItem {
    text-align: center;
    width: 65px;
    cursor:pointer;
    @media (min-width: 1600px) {
      width: 85px;
    }
  }
  .DetailHeader_iconButtonsListItemIcon {
    width: 55px;
    height: 55px;
    background-color: ${colors.color1};
    border-radius: 50%;
    padding-top: 15px;
    text-align: center;
    margin: 0 auto 5px auto;
    @media (min-width: 1600px) {
      width: 75px;
      height: 75px;
      padding-top: 23px;
    }
    img {
      height: 21px;
      @media (min-width: 1600px) {
        height: 28px;
      }
    }
  }
  .DetailHeader_iconButtonsListItemLabel {
    font-size: 12px;
    color: ${colors.color1};
    @media (min-width: 1600px) {
      font-size: 14px;
    }
  }
  .DetailMenu {
    display: none;
    @media (min-width: 992px) {
      width: 100%;
      background-color: ${colors.color1};
      font:700 18px/1 ${typography.SansSerif};
      text-align: center;
      position:relative;
      z-index: 6;
      border-bottom:1px solid #333;
      display:block;
    }
  }
  .DetailMenu_list {
    list-style: none;
    margin: 0;
    display: block;
    position: relative;
    width: auto;
    left: auto;
    margin-left: 0;
    top: auto;
    box-shadow: none;
    text-align: center;
  }
  .DetailMenu_listItem {
    @media (min-width: 992px) {
      display: inline-block;
    }
    a {
      background-color: #FFFFFF;
      padding: 15px;
      border-bottom: 1px solid #EEEEEE;
      display: block;
      color: #333;
      transition: all .25s ease;
      text-decoration: none;
      text-transform: capitalize;
      &.active {
        color: ${colors.color2};
      }
      @media (min-width: 992px) {
          background-color: transparent;
          text-align: center;
          font-weight:700;
          color: ${colors.white};
          padding: 25px 15px;
          border: 0;
          &.active {
            color: ${colors.white};
            background: ${colors.color4};
          }
        }
    }
    a:hover, a:active, a:focus {
      color: ${colors.color4};
      @media (min-width: 992px) {
        color: ${colors.white};
        background: ${colors.color4};
        }
    }
    }
  .DetailSection {
    position: relative;
    .ScrollTarget {
      position: absolute;
      display: block;
      top: -110px;
    }
  }
  .DetailSection_heading {
    color: ${colors.color1};
    padding: 15px 0;
    background-image: url('/images/icon-plus-blue.svg');
    background-position: calc(100% - 5px) center;
    background-repeat: no-repeat;
    background-size: 10px 10px;
    border-top: 1px solid #eeeeee;
    font:700 18px/1 ${typography.Serif};
    outline: 0 !important;
    @media (min-width: 992px) {
      font:700 32px/1 ${typography.Serif};
      border: 0;
      padding: 45px 0 15px 0;
      background-image: none;
    }
  }
  .DetailSection_heading-open {
    background-image: url('/images/icon-minus-blue.svg');
  }
  .DetailSection:last-child {
    .DetailSection_heading {
      border-bottom: 1px solid #eeeeee;
      @media (min-width: 992px) {
        border: 0;
      }
    }
  }
  .DetailSection_featuresImage {
    background-color: #CCCCCC;
    min-height: 300px;
    height: 100%;
    background-position: center center;
    background-size: cover;
    @media (min-width: 992px) {
      padding: 0;
    }
  }
  .DetailSection_featuresHeading {
    font:700 24px/1.2 ${typography.SansSerif};
    color: ${colors.color1};
    margin: 0 0 15px 0;
  }
  .DetailSection_featuresContent {
    background-color: #F5F5F5;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    @media (min-width: 992px) {
      padding: 45px;
    }
  }
  .DetailSection_featuresList {
    ul {
      padding: 0;
      margin: 0 0 0 20px;
      font-size: 16px;
    }
    li {
      margin: 0 0 8px 0;
    }
  }
  .DetailSection_table {
    list-style: none;
    li:last-child {
      .DetailSection_tableLabel, .DetailSection_tableContent {
        border-bottom: 1px solid #EEEEEE;
      }
    }
  }
  .DetailSection_tableLabel {
    background-color: #F5F5F5;
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-weight: 700;
    font-size: 15px;
    height: 100%;
    text-transform:capitalize;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 15px;
    }
  }
  .DetailSection_tableContent {
    border-top: 1px solid #EEEEEE;
    padding: 10px 10px;
    font-size: 15px;
    height: 100%;
    @media (min-width: 992px) {
      font-size: 16px;
      padding: 15px 45px;
    }
  }
  .DetailSection_CTAWrapper {
    width: 100%;
    padding: 30px;
    background-color: ${colors.color2};
    border: 8px solid ${colors.color2Lighter};
    background-image: url('/images/icon-arrow-circle-right.svg');
    background-position: calc(100% - 25px) center;
    background-repeat: no-repeat;
    display: block;
    @media (min-width: 1200px) {
      background-position: calc(100% - 50px) center;
    }
  }
  .DetailSection_CTAHeading {
    font-family: ${typography.Serif};
    font-size: 24px;
    line-height: 1;
    color: #FFFFFF;
    margin: 0 0 10px 0;
    font-weight: 700;
  }
  .DetailSection_CTABody {
    font-size: 18px;
    line-height: 1;
    margin: 0;
    color: #FFFFFF;
  }
  .text-link {
    color: ${colors.color5};
    text-decoration:none;
  }
  .DirectionSection {
    padding-bottom:30px;
    @media (min-width: 992px) {
      padding-bottom:60px;
    }
  }
  .DirectionSection_Media, .DirectionSection_Content {
    padding-bottom:20px;
  }
  p {
    font:300 16px/34px ${typography.SansSerif};
    margin-bottom:20px;
    @media (min-width: 480px) {
      font:300 16px/34px ${typography.SansSerif};
    }
  }
  .Photo_Expand {
    color: ${colors.color2};
    font:700 14px/1 ${typography.SansSerif};
    padding-bottom:20px;
    cursor:pointer;
  }
  .DetailContact {
    display:none;
    @media (min-width: 992px) {
      display:flex;
      flex-flow:row wrap;
      justify-content: center;
      color:white;
    }
    .btn {
      border-radius:6px;
      border:0;
      padding:15px 30px;
      margin:15px 0;
    }
    .DetailContact_Media {
      display:flex;
      flex-flow:column wrap;
      justify-content: center;
      padding:40px 20px 40px 40px;
      background: ${colors.color1};
      img {
        max-width: 100%;
        height:auto;
      }
    }
    .DetailContact_Content {
      display:flex;
      padding:40px 40px 40px 20px;
      background: ${colors.color1};
      flex-flow:column wrap;
      justify-content: center;
      .DetailContact_ContentHeading {
        font:700 32px/1.2 ${typography.Serif};
      }
      .DetailContact_ContentSubheading {
        font:300 22px/1.2 ${typography.SansSerif};
      }
      .DetailContact_ContentTelephone {
        font:700 18px/1.2 ${typography.SansSerif};
      }
    }

  }
  .DetailContact_ContentPhone {
    color:white;
    font-weight:900;
    &:hover {
      color:white;
    }
  }
  .DetailHeader_Address {
    padding:0 15px 15px 15px;
    @media (min-width: 992px) {
      padding:0 ;
    }
  }
  .DetailHeader_price {
    font:700 24px/1.2 ${typography.SansSerif};
    color: ${colors.color1};
    padding:0 15px 15px 15px;
    @media (min-width: 992px) {
      padding:0 0 10px 0;
    }
  }
  .DetailHeader_Hours {
    padding-bottom:20px;
  }
  .FilterSortButton_wrapper {
    display:none;
  }
  .stickymenu {
    top:60px !important;
    @media (min-width: 1199px) {
      top:100px !important;
    }
  }
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function CommunityDetail({ community, builder, homes, plans }) {
  const carouselSlides = [
    get(community, 'logo'),
    ...get(community, 'photos', []),
  ];

  if (get(community, 'tourUrl')) {
    carouselSlides.splice(1, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={get(community, 'tourUrl')} /></div>),
    });
  }

  if (get(community, 'videos', []).length) {
    carouselSlides.splice(1, 0, ...get(community, 'videos', []).map(video => ({
      type: 'video',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`} dangerouslySetInnerHTML={SanitizeHtml(video)} />),
    })));
  }

  return (
    <PageWrapper>
      <PageHelmet community={community} />
      <div className={styles}>
        <div className="DetailHeader">
          <div className="container">
            <div className="row">
              <div className="Breadcrumbs_wrapper">
                <ul className="Breadcrumbs_list">
                  <li className="Breadcrumbs_listItem"><Link name="communities">Communities</Link></li>
                  <li className="Breadcrumbs_listItem">{get(community, 'name')}</li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8 p-0 px-sm-3">
                <Carousel
                  items={carouselSlides}
                  thumbnails
                  mainImageProps={{
                    width: 2000,
                    height: 1125,
                    exact: true,
                  }}
                  thumbnailImageProps={{
                    width: 475,
                    height: 267,
                    exact: true,
                  }}
                />
              </div>
              <div className="col-lg-4">
                <div className="DetailHeader_content">
                  <h1>
                    {get(community, 'name')}<br />
                    {/* <span>
                      {get(community, 'address.addressLocality')},
                      {get(community, 'address.addressRegion')}
                    </span> */}
                  </h1>
                  <strong className="DetailHeader_Address blockit">
                    {get(community, 'address.streetAddress')}<br />
                    <div>
                      {get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}
                    </div>
                  </strong>
                  <ul className="DetailHeader_iconList">
                    {
                      get(community, 'sqftLow') &&
                      <li className="DetailHeader_sqft">
                        <span className="DetailHeader_iconListIcon"><img src="/images/icon-sqft.svg" alt="" /></span>
                        <span className="DetailHeader_iconListItemValue ">{numeral(get(community, 'sqftLow')).format('0,0')}</span>
                        {
                          get(community, 'sqftHigh') &&
                          <span> - {numeral(get(community, 'sqftHigh')).format('0,0')} </span>
                        }
                        <span> Sq Ft</span>
                      </li>
                    }
                  </ul>
                  {
                    get(community, 'priceLow') &&
                    <div className="DetailHeader_price">
                      <span className="DetailHeader_iconListItemValue ">{numeral(get(community, 'priceLow')).format('$0,0')}</span>
                      {
                        get(community, 'priceHigh') &&
                        <span> - {numeral(get(community, 'priceHigh')).format('$0,0')} </span>
                      }
                    </div>
                  }
                  {
                    get(community, 'hours') &&
                    <div className="DetailHeader_Hours">
                        {get(community, 'hours')}
                    </div>
                  }
                  <div className="DetailHeader_buttonsWrapper">
                    <div className="row">
                      {
                        get(community, 'telephone') &&
                        <div className="col-12">
                          <a href={`tel:${get(community, 'telephone').replace(/[^0-9]/g, '')}`} className="btn btn_callToday">Call Today! {get(community, 'telephone').replace(/\s-\s/, '-')}</a>
                        </div>
                      }
                      {
                        !get(community, 'telephone') &&
                        <div className="col-12">
                          <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="btn btn_callToday">Call Today! {get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
                        </div>
                      }
                      <div className="col-12">
                        <ContactModal>
                          <div className="btn btn-reverse blockit">Contact Us</div>
                        </ContactModal>
                      </div>
                    </div>
                  </div>
                  <ul className="DetailHeader_iconButtonsList">
                    {
                      get(community, 'brochure') &&
                      <li className="DetailHeader_iconButtonsListItem">
                        <a href={community.brochure.contentUrl} target="_blank" rel="noopener noreferrer">
                          <div className="DetailHeader_iconButtonsListItemIcon">
                            <img src="/images/icon-download-white.svg" alt="" />
                          </div>
                          <div className="DetailHeader_iconButtonsListItemLabel">Brochure</div>
                        </a>
                      </li>
                    }
                    {
                      get(community, 'videoEmbeds', []).length > 0 &&
                      <LightBox
                        items={get(community, 'videoEmbeds', []).map(video => ({
                          type: 'video',
                          element: (
                            <div
                              className={videoLightBoxStyle}
                              dangerouslySetInnerHTML={SanitizeHtml(video)}
                            />
                          ),
                        }))}
                      >
                        <li className="DetailHeader_iconButtonsListItem">
                          <div className="DetailHeader_iconButtonsListItemIcon">
                            <img src="/images/icon-video-button-white.svg" alt="" />
                          </div>
                          <div className="DetailHeader_iconButtonsListItemLabel">Video</div>
                        </li>
                      </LightBox>
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Sticky style={{ zIndex: 10 }} className="stickymenu">
          <div className="DetailMenu">
            <div className="container">
              <ul className="DetailMenu_list">
                {
                  get(homes, 'length') > 0 &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#comhomes">Available Homes</SmoothLink></li>
                }
                {
                  get(plans, 'length') > 0 &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#complans">Floor Plans</SmoothLink></li>
                }
                {
                  get(community, 'features', []).length > 0 &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#features">Features</SmoothLink></li>
                }
                {
                  (get(community, 'sitePlan.contentUrl') || get(community, 'zplatpublished')) &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#sitePlan">Site Plan</SmoothLink></li>
                }
                {
                  get(community, 'description') &&
                  <li className="DetailMenu_listItem"><SmoothLink href="#overview">Overview</SmoothLink></li>
                }
                <li className="DetailMenu_listItem"><SmoothLink href="#schools">Schools</SmoothLink></li>
                <li className="DetailMenu_listItem"><SmoothLink href="#map">Driving Directions</SmoothLink></li>
              </ul>
            </div>
          </div>
        </Sticky>

        {
          get(homes, 'length') > 0 &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="comhomes" />
            <AccordionToggle
              openOnId="homes"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Available Homes ({get(homes, 'length')})</h3>
                </div>
              )}
            >
              <div className="DetailSection_content">
                <HomesList homes={homes} />
              </div>
            </AccordionToggle>
          </div>
        }
        {
          get(plans, 'length') > 0 &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="complans" />
            <AccordionToggle
              openOnId="plans"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Floor Plans ({get(plans, 'length')})</h3>
                </div>
              )}
            >
              <div className="DetailSection_content">
                <PlansList plans={plans} />
              </div>
            </AccordionToggle>
          </div>
        }
        {
          get(community, 'features', []).length > 0 &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="features" />
            <AccordionToggle
              openOnId="features"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Features</h3>
                </div>
              )}
            >
              {
                get(community, 'features').map(item => (
                  <div className="DetailSection_content" key={item.title}>
                    <div className="container">
                      <div className="row mb-4">
                        <div className="col-lg-5 pr-lg-0">
                          <div className="DetailSection_featuresImage" style={{ backgroundImage: `url(${buildThumbnailUrl(item.photo.contentUrl, { width: 800, height: 800, preserve: true })})` }} />
                        </div>
                        <div className="col-lg-7 pl-lg-0">
                          <div className="DetailSection_featuresContent">
                            <h3 className="DetailSection_featuresHeading">{item.title}</h3>
                            <div className="DetailSection_featuresList" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'feature_list'))} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              }
            </AccordionToggle>
          </div>
        }
        <div className="DetailSection">
          <div className="ScrollTarget" id="overview" />
          <AccordionToggle
            openOnId="overview"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Overview</h3>
              </div>
            )}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-xl-7 mb-4">
                  <p dangerouslySetInnerHTML={SanitizeHtml(get(community, 'description'))} />
                </div>
                <div className="col-lg-6 col-xl-5">
                  {/* className="DetailSection_CTAWrapper" */}
                  <div className="DetailContact">
                    <div className="DetailContact_Media">
                      <img src="/images/icon-detail-contact.png" alt="" />
                    </div>
                    <div className="DetailContact_Content">
                      <h3 className="DetailContact_ContentHeading">Questions?</h3>
                      <h4 className="DetailContact_ContentSubheading">Get Fast Answers!</h4>
                      <ContactModal>
                        <div className="btn">Contact Us</div>
                      </ContactModal>
                      <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="DetailContact_ContentPhone">{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AccordionToggle>
        </div>
        {
          get(community, 'zplatpublished') &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="sitePlan" />
            <AccordionToggle
              openOnId="sitePlan"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Site Plan</h3>
                </div>
              )}
            >
              <SitePlan community={community} homes={homes} />
            </AccordionToggle>
          </div>
        }
        {
          (get(community, 'sitePlan.contentUrl') && !get(community, 'zplatpublished')) &&
          <div className="DetailSection">
            <div className="ScrollTarget" id="sitePlan" />
            <AccordionToggle
              openOnId="sitePlan"
              button={({ contentVisible }) => (
                <div className="container">
                  <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Site Plan</h3>
                </div>
              )}
            >
              <div className="container">
                <Image
                  className="sitePlan-img"
                  src={get(community, 'sitePlan.contentUrl')}
                  // alt={get(homePhoto, 'name', '')}
                />
              </div>
            </AccordionToggle>
          </div>
        }
        <div className="DetailSection">
          <div className="ScrollTarget" id="schools" />
          <AccordionToggle
            openOnId="schools"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Schools</h3>
              </div>
            )}
          >
            <ul className="container DetailSection_table">
              {
                get(community, 'schools', []).length &&
                get(community, 'schools').map(school => (
                  <li className="row" key={school.name}>
                    <div className="col-4 pr-0">
                      <div className="DetailSection_tableLabel">
                        {school.type}
                      </div>
                    </div>
                    <div className="col-8 pl-0">
                      <div className="DetailSection_tableContent">
                        {school.name}
                      </div>
                    </div>
                  </li>
                ))
              }
            </ul>
          </AccordionToggle>
        </div>
        <div className="DetailSection">
          <div className="ScrollTarget" id="map" />
          <AccordionToggle
            openOnId="map"
            button={({ contentVisible }) => (
              <div className="container">
                <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Driving Directions</h3>
              </div>
            )}
          >
            <div className="container">
              <div className="row DirectionSection">
                <div className="col-lg-4 DirectionSection_Content">
                  <p>
                    {get(community, 'directions')}
                  </p>
                  <a href={GoogleMapUrl(community)} target="_blank" className="text-link" rel="noopener noreferrer">
                    <img src="/images/icon-map-pin.svg" alt="" className="mr-2" /> View on Google Map
                  </a>
                </div>
                <div className="col-lg-8 DirectionSection_Media">
                  <CoreMap
                    pin={{
                      iconUrl: '/images/icon-map-pin.svg',
                      iconSize: [32, 46],
                      iconAnchor: [16, 46],
                    }}
                    className={css`
                      position: relative;
                      padding-bottom: 56.25%;
                      width: 100%;
                      z-index: 0;

                      background-color: ${colors.color3};
                      .leaflet-container {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                      }
                    `}
                    markers={[community]}
                  />
                </div>
              </div>
            </div>
          </AccordionToggle>
        </div>
      </div>
    </PageWrapper>
  );
}

CommunityDetail.propTypes = {
  builder: PropTypes.object.isRequired,
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
};

CommunityDetail.defaultProps = {
  community: undefined,
  homes: undefined,
  plans: undefined,
};

export default withData(
  {
    builder: true,
    community: true,
    homes: true,
    plans: true,
  },
  {
    required: {
      community: true,
      builder: true,
    },
    ifMissing404: true,
  },
)(CommunityDetail);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/index.js